import * as React from 'react';

import type { RevisionPageIconProps } from '@gitbook/hive-core';
import { Button, EmojiPicker, IconPicker, Tab, Tabs } from '@gitbook/spine-react';

interface PageIconPickerProps {
    value: RevisionPageIconProps;
    onChange: (value: RevisionPageIconProps) => void;
}

/**
 * Component to pick an emoji or icon for a page.
 */
export function PageIconPicker(props: PageIconPickerProps) {
    const { value, onChange } = props;

    const [query, setQuery] = React.useState('');
    const [tab, setTab] = React.useState<'emoji' | 'icons'>(value.emoji ? 'emoji' : 'icons');

    return (
        <div className="mx-auto">
            <div className="flex flex-1 items-end gap-4 border-b px-3 pt-1">
                <Tabs className="flex-1">
                    <Tab active={tab === 'icons'} onPress={() => setTab('icons')} label="Icons" />
                    <Tab active={tab === 'emoji'} onPress={() => setTab('emoji')} label="Emojis" />
                </Tabs>
                {value.icon || value.emoji ? (
                    <div className="flex py-[2px]">
                        <Button
                            onPress={() => {
                                onChange({});
                            }}
                            label="Remove"
                            size="medium"
                            kind="blank"
                        />
                    </div>
                ) : null}
            </div>
            {tab === 'emoji' ? (
                <EmojiPicker
                    onPick={(emoji) => {
                        onChange({ emoji });
                    }}
                    query={query}
                    onChangeQuery={setQuery}
                />
            ) : null}
            {tab === 'icons' ? (
                <IconPicker
                    onPick={(icon) => {
                        onChange({ icon });
                    }}
                    query={query}
                    onChangeQuery={setQuery}
                />
            ) : null}
        </div>
    );
}
